import styled from "styled-components";

export const FooterContainer = styled.footer`
  font-size: 1.2rem;
  font-weight: 400;
  text-align: center;
  color: ${(props) => props.theme.secondary};
  margin-top: auto;
`;
